import {QT} from '../globals/config';

const $ = jQuery;

/**
 * SETTER FUNCTIONS
 * Set specific values for @var userSelect global variable.
 */

export function setIssue(element) {
    if ($(element).closest('section[data-step-name="reports"]').length) {
        QT.issue = element.textContent;

        QT.issue = QT.issue.replaceAll('\n', '');
        QT.issue = QT.issue.replaceAll('\t', '');
    }
}

export function setServiceName() {
    let serviceNames = [];

    $('.js-qt-diagnosis-service-name').each(function() {
        let serviceName = $(this).text();
        if (serviceName) {
            serviceNames.push(serviceName);
        }
    });

    QT.serviceName = serviceNames;
}
